<template>
  <div id="contenedor-contrato-insumos-main">
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:nuevoInsumo="registrarnuevoInsumo"
    >
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <template v-if="getContratoInsumos.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay insumos registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-card
        flat>
        <v-card-text>
          <listado
            v-if="!$apollo.loading"
            :listadoInsumos="listado">
          </listado>
        </v-card-text>
      </v-card>
    </template>
    <!-- Ventana Agregar Insumo Contrato -->
    <v-dialog
      v-if="mostrarAgregarInsumo"
      v-model="mostrarAgregarInsumo"
      width="600"
      persistent>
      <agregar-insumo
        :idContrato="this.idContrato"
        v-on:cerrar="cerrarVentana"
      >
      </agregar-insumo>
    </v-dialog>
    <!-- Ventana Editar Insumo Contrato -->
    <v-dialog
      v-if="esteInsumo"
      v-model="mostrarEditarInsumo"
      width="500">
        <editar-insumo
          :contratoInsumoEditar="esteInsumo"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
    <!-- Ventana Eliminar Insumo Contrato -->
    <v-dialog
      v-if="esteInsumo"
      v-model="mostrarEliminarInsumo"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
        <eliminar-insumo
          :contratoInsumoEliminar="esteInsumo"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_INSUMOS from '@/graphql/querys/administracion/contratos/insumos/contratoInsumos.gql';
import ToolBar from './ToolBar.vue';
import AgregarInsumo from '@/components/administracion/contratos/contrato/insumos/Agregar.vue';
import EditarInsumo from '@/components/administracion/contratos/contrato/insumos/Editar.vue';
import EliminarInsumo from '@/components/administracion/contratos/contrato/insumos/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoInsumosMain',
  components: {
    ToolBar,
    Listado,
    AgregarInsumo,
    EditarInsumo,
    EliminarInsumo,
  },
  data() {
    return {
      idContrato: this.$route.params.idContrato,
      mostrarAgregarInsumo: false,
      mostrarEditarInsumo: false,
      mostrarEliminarInsumo: false,
      esteInsumo: null,
    };
  },
  methods: {
    registrarnuevoInsumo() {
      this.mostrarAgregarInsumo = true;
    },
    cerrarVentana() {
      this.mostrarAgregarInsumo = false;
      this.mostrarEditarInsumo = false;
      this.mostrarEliminarInsumo = false;
      this.esteInsumo = null;
    },
  },
  apollo: {
    contratoInsumos: {
      query: CONTRATO_INSUMOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    getContratoInsumos() {
      if (!this.contratoInsumos) return [];
      return this.contratoInsumos
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    listado() {
      return [
        {
          agrupador: 'Personal',
          insumos: this.getContratoInsumos
            .filter(({ insumo }) => insumo.tipo === 1)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Maquinaria',
          insumos: this.getContratoInsumos
            .filter(({ insumo }) => insumo.tipo === 2)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Equipo',
          insumos: this.getContratoInsumos
            .filter(({ insumo }) => insumo.tipo === 3)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
      ];
    },
  },
  mounted() {
    eventBus.$on('editar-insumo-contrato', (insumoContrato) => {
      this.esteInsumo = insumoContrato;
      this.mostrarEditarInsumo = true;
    });
    eventBus.$on('eliminar-insumo-contrato', (insumoContrato) => {
      this.esteInsumo = insumoContrato;
      this.mostrarEliminarInsumo = true;
    });
  },
};
</script>

<style lang="scss">
</style>
